import React from "react";
import {FormattedMessage} from "react-intl";

export default function translateNoteContent(content) {
    const commandRegex = /Je me suis affecté la commande: #(.*)/g;
    const commandMatches = commandRegex.exec(content);
    if (commandMatches) {
        return (
            <FormattedMessage
                id="picking.order.show.note.affected_command"
                values={{orderId: commandMatches[1]}}
            />
        );
    }

    const articleRegex = /Je me suis affecté l'article: (.*)/g;
    const articleMatches = articleRegex.exec(content);
    if (articleMatches) {
        return (
            <FormattedMessage
                id="picking.order.show.note.affected_article"
                values={{lineItemName: articleMatches[1]}}
            />
        );
    }

    return content;
}
